import React from 'react';
import VideoItem from './VideoItem';
import './SideBar/style.css'


const VideoList = ({videos, onVideoSelect}) => {
   const renderedList= videos.map((video)=>{
       return <VideoItem onVideoSelect={onVideoSelect} video={video} key={video.title} />
       {/**video.videoId */}
    })
    return (
        <div >
         <h6 className="ui relaxed divided list btn btn-white " style={{margin:'2px',fontSize:'12px'}}>{renderedList}</h6>
        </div>
    );
};

export default VideoList;